<div class="background"></div>
<div class="container">
  <img
    src="../../../../assets/img/tc-davivienda/Logo davivienda.png"
    alt="Logo Davivienda"
    class="logo"
  />
  <div class="wrapper">
    <div class="tc-davivienda">
      <app-tc-home></app-tc-home>
      <app-no-tc-davivienda [modalType]="modalType"></app-no-tc-davivienda>
      <div class="tc-content">
        <app-tc-form
          (btnContnue)="getValidateId($event)"
          (nomDocument)="getDocumento($event)"
          [title]="title"
          [subtitle]="subtitle"
          [typeDocument]="typesDocuments"
          [typeFunction]="typeFunction"
        ></app-tc-form>
      </div>
    </div>
  </div>
  <footer class="footer">
    <div class="disclamer-davivienda">
      <div class="cobranding_logo">
        <img
          src="../../../../assets/img/tc-davivienda/Logo Davivienda-Servicios Bolivar.svg"
          alt="Davivienda"
          class="davivienda"
        />
      </div>
      <div class="text-davivienda">
        <p>
          {{ textDavivienda }}
        </p>
      </div>
      <div class="footer-disclamer">
        <p> {{ tcDaviviendaHome?.footer ?? 'Recuerde que por su seguridad el Banco Davivienda nunca solicita a
          través de este medio información confidencial o financiera como
          usuarios y claves de acceso a nuestros canales, ni números de productos como cuentas,
          números de tarjetas de crédito o similares.' }}
        </p>
        <img
          src="../../../../assets/img/tc-davivienda/cobranding 1.png"
          alt="Cobranding Davivienda"
          class="cobranding"
        />
      </div>
    </div>
  </footer>
</div>
